import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Modal from 'react-bootstrap/Modal';
import Loader from "../../../shared/Loader/Loader"
import axios from "axios";
import SuperSearch from "../../../shared/SuperSearch/SuperSearch"
import AddNewDiagnosis from "./AddNewDiagnosis"
import { FindSecondChild } from "../../../../utils/FindMenuOption"

const AddNewDiagnosisNewDesign = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'Diagnosis')?.IsAdd

    const [isLoading, setIsLoading] = useState(false)
    const [onDiagnosisSave, setOnDiagnosisSave] = useState(false)
    const API_URL = enumUtil.controller.General
    const { isOpenDiagnosis, onClose, onDeleteDiagnosis, type, IsOpen, Diagnosisvalue } = { ...props }
    const [conform, setConfrom] = useState(false)
    const [isOpenDiagnosiss, setisOpenDiagnosis] = useState(false)
    const [ICDCode, setICDCode] = useState({
        DiagnosisCode: "",
        Description: "",
        valid: ""
    })
    const [editIndex, setEditIndex] = useState([]);
    const [selectedValues, setSelectedValues] = useState([]);

    const checkDiagnosisCode = (value) => {
        return axios
            .get(`https://icd10api.com/?code=${value}&desc=short&r=json`)

            .then((response) => {
                if (response.data?.Valid !== undefined) {
                    return response.data.Valid;
                } else {
                    return response?.data?.Error;
                }
            })
            .catch((error) => {
                console.error("API error:", error);
                return null;
            });
    };
    const handleEditChange = (event, index) => {
        const newCode = event.target.value;
        setSelectedValues((prevData) =>
            prevData.map((data, i) =>
                i === index ? { ...data, Description: newCode } : data
            )
        );
    };
    const handleDiagnosisChangee = (e) => {
        let { name, value } = e.target
        let modal = { ...ICDCode }
        modal["DiagnosisCode"] = value
        setICDCode(modal)
    }
    const handleSelectDiagnosisData = async (selectedData, name, type) => {

        if (type === 'client' && !isNull(selectedData)) {
        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'DiagnosisCode') {
                const diagnosisValid = await checkDiagnosisCode(selectedData.Name)
                console.log(selectedData, 'selectDat');

                selectedData.DiagnosisCode = selectedData.Name + "";
                selectedData.Description = selectedData.Description + "";
                ICDCode.DiagnosisCode = ""
                if (diagnosisValid === "1") {
                    ICDCode.valid = "Valid"
                    selectedData.valid = "Valid";
                }
                else if (diagnosisValid === "0") {
                    ICDCode.valid = "Invalid"
                    selectedData.valid = "Invalid";
                }
                else if (diagnosisValid === null) {
                    ICDCode.valid = "Invalid"
                    selectedData.valid = "Invalid";
                }

                setSelectedValues((prevValues) => [...prevValues, selectedData]);
            }
        }
        return selectedData;
    };
    const handleDelete = (deleteIndex) => {
        setSelectedValues((prevData) => prevData.filter((_, index) => index !== deleteIndex));
    };
    const handleEditClick = (index, name) => {

        if (name === 'Edit') {
            if (!editIndex.includes(index)) {
                setEditIndex([...editIndex, index])
            }
        }
        else if (name === 'Close') {
            setEditIndex(editIndex.filter((rowIndex) => rowIndex !== index))
        }
    };
    const closeconfrom = () => {
        setConfrom(false)
    }
    const newSave = () => {
        if (IsEditAllowed) {
            const validation = selectedValues?.some(item => item.valid === "Invalid");
            if (validation) {
                setConfrom(true)
            }
            else {
                handleSave()
            }
        }
    }
    const handleSave = () => {
        const validation = selectedValues?.some(item => item.valid === "Invalid");
        {
            const uniqueSelectedValues = selectedValues
                ?.filter((item, index, array) =>
                    array.findIndex(i => i.DiagnosisCode === item.DiagnosisCode) === index
                )
                .map(item => {
                    const { valid, Name, ...rest } = item;
                    return rest;
                });



            let saveModal = {
                TableName: enumUtil.enumAPITableName.Diagnosis,
                "Data": uniqueSelectedValues
            }
            console.log(saveModal, 'saveModal');

            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveBulkDiagnosisCode", 'post', saveModal)
                .then((response) => {
                    setIsLoading(false)
                    onDeleteDiagnosis()
                    setConfrom(false)
                    setOnDiagnosisSave(true)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const AddDiagnosis = () => {
        setisOpenDiagnosis(true)
    }
    const CloseDiagnosis = () => {
        setisOpenDiagnosis(false)
    }
    const DeleteDiagnosis = () => {
        setisOpenDiagnosis(false)
    }
    let PopupScreen = "";

    if (isOpenDiagnosiss) {
        PopupScreen = (
            <AddNewDiagnosis
                isOpenDiagnosis={isOpenDiagnosiss}
                onClose={CloseDiagnosis}
                onDeleteDiagnosis={DeleteDiagnosis}
            />
        );
    }
    return (
        <>
            {isLoading ? <Loader /> : null}
            {PopupScreen}
            <Modal show={isOpenDiagnosis} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName=" hk-modal-v1 za-payerlist za_add-diagnosis-code">
                <Modal.Body>
                    {/* <div className='d-flex justify-content-between align-items-center mb-2 px-10'>
                        <p className='heading fs-14'>Add New Diagnosis Code</p>
                        <i className='icon-Icon-metro-cross' onClick={onDiagnosisSave ? onDeleteDiagnosis : onClose}></i>
                    </div> */}
                    <div className="d-flex align-items-center justify-content-between mb-12 px-10">
                        <div className="">
                            <p className="heading dark-clr fs-14">Add New Diagnosis Code</p>
                        </div>
                        <i className="icon-x-cros fs-20 dark-clr" onClick={onDiagnosisSave ? onDeleteDiagnosis : onClose}></i>
                    </div>

                    <div className='px-10'>
                        <div className="col-md-12 input popup_super_search no-round-right
 ">
                            <div className="input">
                                <div className='input-group hk-input-search flex-nowrap'>

                                    <SuperSearch
                                        ApiLink={`http://icd10api.c`}
                                        method="get"
                                        type={"server"}
                                        id='DiagnosisCode'
                                        name='DiagnosisCode'
                                        getSelectedData={handleSelectDiagnosisData}
                                        onChange={handleDiagnosisChangee}
                                        searchValue={ICDCode.DiagnosisCode}
                                        tableData={[
                                            { columName: 'Code', bindingValue: 'Name', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                        ]}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        typefrom={'Diagnosis'}
                                        handleAddNewCode={AddDiagnosis}
                                    />

                                    <span className="input-group-text rounded-end">
                                        <i className="bi bi-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className='add_data mx-10 d-flex align-items-center'>
                        <p className='heading  fs-12'>Added Data</p>
                    </div>
                    <div className='card-body hk-expand-table ad-expand-table service_line px-10'>
                        <table>
                            <thead>
                                <tr>
                                    <th className='heading fs-12 text-white'>Code</th>
                                    <th className='heading fs-12 text-white'>Description</th>
                                    <th className='heading fs-12 text-white'>Status</th>
                                    <th className='heading fs-12 text-white'>Actions</th>
                                </tr>
                            </thead>
                            <tbody>

                                {selectedValues?.length > 0 ? (
                                    selectedValues?.map((data, index) => (
                                        <tr key={index}>
                                            <td className='text fs-12'>
                                                {data.DiagnosisCode}
                                            </td>
                                            <td className='text fs-12'>
                                                <p className='validation_message text-nowrap'>
                                                    {editIndex.includes(index) ? (
                                                        <input
                                                            type='text'
                                                            id="Description"
                                                            name="Description"
                                                            value={data.Description}
                                                            onChange={(e) => handleEditChange(e, index)}
                                                        />
                                                    ) : (
                                                        data.Description
                                                    )}

                                                </p>
                                            </td>
                                            <td className='text fs-12'>
                                                <p className={`validation_message text-nowrap text-center ${data.valid === "Valid" ? 'Yes' : 'No'}`}>
                                                    {data.valid}
                                                </p>
                                            </td>
                                            <td className='text fs-12'>
                                                <div className='d-flex gap-1'>
                                                    {editIndex.includes(index) ? <i className='icon-close fs-10' onClick={() => handleEditClick(index, "Close")}></i> : <i className='icon-Icon-material-edit fs-13' onClick={() => handleEditClick(index, "Edit")}></i>}


                                                    <i className='icon-delete text-danger fs-14' onClick={() => handleDelete(index)}></i>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className='text fs-12'>No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body >
                {/* <div className="modal_footer  ar-border-color br-top-1 ">
                    <div className='za-button text-end'>
                        <button className='btn btn-orange text fs-12 px-10 text-white' onClick={newSave}> Save</button>
                    </div>
                </div> */}
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className={IsEditAllowed ? 'btn btn-validate px-10 h-100' : 'btn btn-validate px-10 h-100 disabled'} onClick={newSave}>Save</button>
                </div>

            </Modal >

            {/* <Modal show={conform} onHide={closeconfrom} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 ar_delte_modal">
                <div className='d-flex justify-content-between delete-header align-items-center'>
                    <div>
                        <p className="heading">ICD Code Confirmatiom</p>
                    </div>
                    <div>
                        <i className='icon-Icon-metro-cross' onClick={closeconfrom}></i>
                    </div>
                </div>
                <div className='undo-body'>
                    <div className="input">
                        <label className='heading'> Some of the ICD code(s) looks invalid, do you still want to save it?</label>
                    </div>
                </div>
                <div className='btns-group  text-end pb-2 px-2'>
                    <button className='btn btn-gray' onClick={closeconfrom}>No</button>
                    <button className='btn btn-orange' onClick={handleSave}>Yes</button>
                </div>


            </Modal> */}
            <Modal show={conform} onHide={closeconfrom} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 za-update-subscriber-id za-discard-changes za-exit-group ">
                <Modal.Body>
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="heading fs-14 dark-clr">Confirm Selection</p>
                        <i className="icon-x-cros fs-20 fs-20 dark-clr" onClick={closeconfrom}></i>
                    </div>
                    <div className='ar-alert d-flex align-items-center gap-2 w-100 mb-0 mt-12'>
                        <i className='icon-alert fs-16'></i>
                        <div>
                            <p className='text'>Some of the ICD code(s) looks invalid, do you still want to save it?</p>
                        </div>
                    </div>
                </Modal.Body>

                <div className="modal_footer za_br_light br-top-1 pt-2 ">
                    <div className='za-button text-end d-flex justify-content-end gap-2'>
                        <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={closeconfrom}>No</button>
                        <button className='btn btn-danger fs-12 px-10 rounded' onClick={handleSave}>Yes</button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default AddNewDiagnosisNewDesign